import store from '@/store';
import { GLOBAL_MODAL_OPEN, GLOBAL_MODAL_CLOSE } from './storeTypes';

export default {
  install(Vue) {
    Vue.prototype.$modal = {
      open({ title, component, props, ...options }) {
        return new Promise(resolve => {
          store.dispatch(GLOBAL_MODAL_OPEN, {
            title,
            component,
            props,
            resolve,
            options,
          });
        });
      },
      close(result) {
        store.dispatch(GLOBAL_MODAL_CLOSE, result);
      },
    };
  },
};
